import React from "react";
import { adhd, Carousel2, anxiety, Bipolardisorder } from "../assets";
import { Link } from "react-router-dom";
import "../index.css";

const CarouselItems = [
  {
    src: Carousel2,
    alt: "Carousel 1",
    title: "Depression",
    description: "Addressing your depression symptoms and their causes.",
    link: "/depression", // URL for the Depression page
  },
  {
    src: anxiety,
    alt: "Carousel 2",
    title: "Anxiety",
    description: "Healthy coping mechanisms for irrational worries.",
    link: "/anxiety", // URL for the Anxiety page
  },
  {
    src: adhd,
    alt: "adhd",
    title: "ADHD",
    description: "Managing hyperactivity and Attention deficit.",
    link: "/adhd", // URL for the ADHD page
  },
  {
    src: Bipolardisorder,
    alt: "Carousel 4",
    title: "Bipolar Disorder",
    description: "Treatments for fluctuating moods and energy levels.",
    link: "/bipolardisorder",
  },
];

const CarouselCard = ({ src, alt, title, description, link }) => (
  <div className="group bg-white rounded-xl shadow-soft hover:shadow-medium transition-all duration-300 overflow-hidden">
    <div className="relative overflow-hidden">
      <img
        className="w-full h-56 md:h-64 object-cover transition-transform duration-500 group-hover:scale-105"
        src={src}
        alt={alt}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
    </div>
    <div className="p-6">
      <h5 className="text-heading-md text-neutral-900 mb-3 text-center group-hover:text-primary-600 transition-colors duration-300">
        {title}
      </h5>
      <p className="text-body-md text-neutral-600 mb-5 text-center leading-relaxed">
        {description}
      </p>
      <div className="flex justify-center">
        <Link to={link}>
          <button className="px-6 py-2.5 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-all duration-300 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
            Learn More
          </button>
        </Link>
      </div>
    </div>
  </div>
);

const Services = () => (
  <div className="py-16 md:py-20 lg:py-24 bg-white">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-12 md:mb-16">
        <h2 className="text-heading-xl md:text-display-sm text-neutral-900 mb-4">
          Our Services
        </h2>
        <p className="text-body-lg md:text-heading-sm text-neutral-600 max-w-3xl mx-auto leading-relaxed">
          Empowering minds, restoring hope. Our mental health services are anchored
          in compassion, expertise, and a commitment to your well-being.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
        {CarouselItems.map((item, index) => (
          <CarouselCard
            key={index}
            src={item.src}
            alt={item.alt}
            title={item.title}
            description={item.description}
            link={item.link}
          />
        ))}
      </div>
    </div>
  </div>
);

export default Services;
